var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 213,
    viewBox: "0 0 256 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 257,
    height: 212
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.003 0.328125H0V211.267H256.003V0.328125Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 139.993V0.328125L64.102 70.4118L128.481 0.328125L192.002 70.0486L256.003 0.328125V140.315L192.721 211.267L128.481 141.274L64.2404 211.267L0 139.993Z",
    fill: "#5B2E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1222 105.797C38.7765 98.5125 60.1913 75.0718 64.2404 70.6386C56.1039 61.7353 13.2756 14.8599 0 0.328125C0.809825 2.98883 28.8657 95.1059 32.1222 105.797Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000816664 0.328554L23.5214 25.832L48.9931 107.149L24.2364 114.718L-0.000816664 0.328554Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8711 115.545L22.532 84.6284L57.6485 63.4844L71.5805 78.6441L31.8711 115.545Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.762 70.3179L256.002 140.315V0.328125L191.762 70.3179Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.781 70.3497L205.152 55.7966L256.003 112.509L256.003 140.314L191.781 70.3497Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.72 211.267L256.002 140.315L168.75 44.4336L192.72 211.267Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.48 141.274L192.721 211.267L168.751 44.4336L128.48 141.274Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2402 211.267L128.481 141.274V0.328125L64.2402 211.267Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2402 211.267L89.3613 183.896L128.481 41.5033V0.328125L64.2402 211.267Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.48 141.274L168.751 44.4335L128.48 0.328125V141.274Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6406 105.661C33.8397 112.866 64.2446 211.267 64.2446 211.267L128.481 0.328125L31.6406 105.661Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0419 108.428L51.7766 83.7593L83.944 189.821L64.2412 211.266L29.0419 108.428Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 140.774L64.2404 211.267L0.0026355 0.328125L0 140.774Z",
    fill: "url(#paint12_linear)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8.30757,
    y1: 9.87521,
    x2: 68.9304,
    y2: 55.8526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67337A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#723986"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 30.8181,
    y1: 54.7877,
    x2: 15.384,
    y2: 59.5064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#623274",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 38.7493,
    y1: 76.2705,
    x2: 49.7207,
    y2: 91.9393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#623274",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 250.654,
    y1: 8.16597,
    x2: 186.873,
    y2: 69.4912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A519F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A53A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 231.746,
    y1: 94.4107,
    x2: 220.513,
    y2: 106.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A529F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 190.3,
    y1: 96.8209,
    x2: 251.641,
    y2: 117.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C2E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D377B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 136.412,
    y1: 101.921,
    x2: 183.809,
    y2: 106.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#612E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F4395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 128.481,
    y1: 0.328125,
    x2: 128.481,
    y2: 146.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#582C6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743983"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 96.3604,
    y1: 158.085,
    x2: 76.6648,
    y2: 157.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#623274",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 128.48,
    y1: 0.328125,
    x2: 128.48,
    y2: 141.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#723A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C519C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 31.6406,
    y1: 76.1121,
    x2: 93.383,
    y2: 81.0225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66397A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F69AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 61.73,
    y1: 144.044,
    x2: 41.7941,
    y2: 150.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#623274",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 32.1202,
    y1: 44.7075,
    x2: 32.1202,
    y2: 165.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D306E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F6AAA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 213,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebix);
export default __webpack_public_path__ + "static/media/webix.99dfb57fb4bc6e1c39d735e6a4ee66ca.svg";
export { ForwardRef as ReactComponent };